export default class OpeningHours{

    hours : any;


    constructor() {
        this.hours = this.getHours();
    }


    getHours() {
        const arr = [
            {
                place: 'Büro / Ersatzteillager / Werkstatt',
                hours : [
                    {
                    day: 'Montag',
                    fromVor: '07:30',
                    toVor: '12:00',
                    fromNach: '13:15',
                    toNach: '16:30'
                    },
                    {
                        day: 'Dienstag',
                        fromVor: '07:30',
                        toVor: '12:00',
                        fromNach: '13:15',
                        toNach: '16:30'
                    },
                    {
                        day: 'Mittwoch',
                        fromVor: '07:30',
                        toVor: '12:00',
                        fromNach: '13:15',
                        toNach: '16:30'
                    },
                    {
                        day: 'Donnerstag',
                        fromVor: '07:30',
                        toVor: '12:00',
                        fromNach: '13:15',
                        toNach: '16:30'
                    },
                    {
                        day: 'Freitag',
                        fromVor: '07:30',
                        toVor: '12:00',
                        fromNach: '13:15',
                        toNach: '16:30'
                    },
                    {
                        day: 'Samstag',
                        fromVor: '07:30',
                        toVor: '12:00',
                        fromNach: 'Nachmittags',
                        toNach: 'geschlossen'
                    },

                ]
            },
            {
                place: 'Verkauf – Neu- und Gebrauchtmaschinen',
                hours : [
                    {
                        day: 'Montag',
                        fromVor: '07:30',
                        toVor: '12:00',
                        fromNach: '13:15',
                        toNach: '17:00'
                    },
                    {
                        day: 'Dienstag',
                        fromVor: '07:30',
                        toVor: '12:00',
                        fromNach: '13:15',
                        toNach: '17:00'
                    },
                    {
                        day: 'Mittwoch',
                        fromVor: '07:30',
                        toVor: '12:00',
                        fromNach: '13:15',
                        toNach: '17:00'
                    },
                    {
                        day: 'Donnerstag',
                        fromVor: '07:30',
                        toVor: '12:00',
                        fromNach: '13:15',
                        toNach: '17:00'
                    },
                    {
                        day: 'Freitag',
                        fromVor: '07:30',
                        toVor: '12:00',
                        fromNach: '13:15',
                        toNach: '17:00'
                    },
                    {
                        day: 'Samstag',
                        fromVor: '08:30',
                        toVor: '12:00',
                        fromNach: 'Nachmittags',
                        toNach: 'geschlossen'
                    },

                ]
            }
        ];

        return arr;
    }

}